import React from "react";

interface MetricsListItem {
  label: string;
  value: number;
  color?: string;
  testId?: string;
  onClick?: () => void;
}

export interface MetricsListProps {
  label: string;
  items: MetricsListItem[];
}

const MetricsList: React.FC<MetricsListProps> = ({ label, items }) => {
  const allZero = items.every((item: MetricsListItem) => item.value === 0);
  const maxValue = Math.max(...items.map((item: MetricsListItem) => item.value), 1);
  const MIN_BAR_PERCENT = 2;

  return (
    <div className={`metrics-list${allZero ? " metrics-list--empty" : ""}`}>
      <div className="metrics-list__label">{label}</div>
      <div className="metrics-list__items">
        {items.map((item: MetricsListItem) => (
          <div
            key={item.label}
            className={`metrics-list__item${!allZero && item.onClick ? " metrics-list__item--clickable" : ""}`}
            onClick={!allZero && item.onClick ? item.onClick : undefined}
            data-testid={!allZero ? item.testId : undefined}
          >
            <div className="metrics-list__item-content">
              <span className="metrics-list__item-label">{item.label}</span>
              <div className="metrics-list__item-bar">
                {!allZero && item.value > 0 && (
                  <div
                    className="metrics-list__item-bar-fill"
                    style={{
                      backgroundColor: item.color,
                      width: `${Math.max((item.value / maxValue) * 100, MIN_BAR_PERCENT)}%`
                    }}
                  />
                )}
              </div>
            </div>
            <span className="metrics-list__item-value">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetricsList;